module.exports = "<div ng-class=\"{ 'disabled': $ctrl.isDisabled() }\" ng-click=\"$ctrl.mandatoryInsuranceAlert()\">\n  <p ng-if=\"$ctrl.label\" class=\"label\">{{$ctrl.label}}</p>\n  <switch id=\"ui-switch\" ng-model=\"$ctrl.enabled\"></switch>\n</div>\n\n<loans-mandatory-insurance-modal\nerror=\"$ctrl.showAlert\"\nmessage=\"$ctrl.alertMessage\"\nis-mobile-app=\"$ctrl.isMobileApp\">\n</loans-mandatory-insurance-modal>"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/toggleSwitch/toggleSwitch.html
// module id = 708
// module chunks = 0